module.exports = __webpack_public_path__ + "static/media/message-prompt.fdd1fae.mp3";


//////////////////
// WEBPACK FOOTER
// ./packages/assets/message-prompt.mp3
// module id = 2/+M
// module chunks = 1